import {
  Box,
  LinearProgress,
  Modal,
  Snackbar,
  Typography,
  CircularProgress,
  Link,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import styles from "../../styles/Common.module.css";

import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useRouter } from "next/router";
import ComingSoonModal from "./ComingSoonModal";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { getCookie } from "../utils/cookie";
import { useDispatch } from "react-redux";
import { updateProductCount } from "../../redux/fetcher/TarrotCardSlice";
import ShopLazyLoader from "../shopLazyLoader/shopLazyLoader";
import FloatingCartButton from "../FloatingCartButton/FloatingCartButton";

const ClothingModal = ({
  openClothingDetailsModal,
  setOpenClothingDetailsModal,
  shopDetails,
}) => {
  const dispatch = useDispatch();
  console.log("openClothingDetailsModal", openClothingDetailsModal);
  console.log("setOpenClothingDetailsModal", setOpenClothingDetailsModal);
  console.log("shopDetails", shopDetails);

  const [navigationLoading, setNavigationLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const [cartCount, setCartCount] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const [colorError, setColorError] = useState(false);

  const handleNewClose = async () => {
    setLoaderOpen(true);

    let obj = {
      searchcondition: {
        user_id: getCookie("guest_id"),
      },
      sort: {
        type: "asc",
        field: "priority",
      },
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...obj }),
    };
    let rep = await fetch(
      `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
      requestOptions
    );
    rep = await rep.json();
    console.log("rep============>", rep);
    if (rep.status == "success") {
      const count = rep.results.res?.reduce(
        (accumulator, currentValue) => accumulator + currentValue.quantity,
        0
      );
      localStorage.setItem("cartCount", parseInt(count));
      dispatch(updateProductCount(parseInt(count)));
    }
    setOpenClothingDetailsModal(false);
    setLoaderOpen(false);
  };

  const handleNavigation = async (direction) => {
    if (navigationLoading) return;

    setNavigationLoading(true);

    try {
      const currentProductId = localShopDetails.product_details._id;

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          current_product_id: currentProductId,
          direction: direction,
          user_id: getCookie("user_id") || getCookie("guest_id"),
        }),
      };

      let response = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}product-management/navigate-product`,
        requestOptions
      );

      response = await response.json();

      console.log("Product Response-------->>", response);

      if (response.status === "success" && response.product_id) {
        let detailsBody = {
          product_id: response.product_id,
          user_id: getCookie("user_id")
            ? getCookie("user_id")
            : getCookie("guest_id"),
        };

        let detailsData = await fetch(
          `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/get-product-detail-for-user`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(detailsBody),
          }
        );

        detailsData = await detailsData.json();
        console.log("detailsData", detailsData);

        if (detailsData.status == "success") {
          setLocalShopDetails(detailsData);
          // Reset modal loading state when new product data is loaded
          setModalInitialLoading(true);
        }
      } else {
        setSnackbarState(true);
        setSnackMsg(
          direction === "prev" ? "No previous product" : "No next product"
        );
      }
    } catch (error) {
      console.error("Navigation error:", error);
      setSnackbarState(true);
      setSnackMsg("Error loading product");
    } finally {
      setNavigationLoading(false);
    }
  };

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;
  const hideCartOnThisRoute =
    router.pathname === "/shop/cart" ||
    router.pathname === "/payment-success-page" ||
    router.pathname === "/login" ||
    router.pathname === "/subscription";

  const [copyRightOpen, setCopyRightOpen] = useState(false);
  const copyRightMOdal = () => {
    setCopyRightOpen(true);
  };

  const [image, setImage] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");
  const [outofstockText, setOutofstockText] = useState("");
  const [isOutOfStock, setIsOutOfStock] = useState(false);

  const [showingImages, setShowingImages] = useState([]);
  const [selectedSize, setselectedSize] = useState(null);
  const [selectedVeriant, setselectedVeriant] = useState(null);
  const [selectedColour, setselectedColour] = useState(null);
  const [productDetailsOpen, setProductDetailsOpen] = useState(true);
  const [shippingReturnsOpen, setShippingReturnsOpen] = useState(false);
  const [showAllColors, setShowAllColors] = useState(false);
  const [localShopDetails, setLocalShopDetails] = useState(shopDetails);
  const [maxAvailableStock, setMaxAvailableStock] = useState(null);
  const [initialImageLoading, setInitialImageLoading] = useState(true);
  // NEW STATE: Track modal initial loading
  const [modalInitialLoading, setModalInitialLoading] = useState(true);

  const isMoreThanTwoDigitNumber = (val) => {
    if (val == null) return false;
    const s = String(val).trim();
    const m = s.match(/^\d+/);
    return !!m && m[0].length > 2;
  };

  const findColorOrsize = async (veriant, productDetails) => {
    let colorCode;
    let size;
    if (productDetails && productDetails.colors.length > 0) {
      let colorFind = productDetails?.colors.find(
        (pro) => pro.id === veriant.options[0]
      );

      if (colorFind) {
        colorCode = veriant.options[0];
      } else {
        colorCode = veriant.options[1];
      }
    }

    if (productDetails && productDetails.size.length > 0) {
      let sizeFind = productDetails?.size.find(
        (pro) => pro.id === veriant.options[0]
      );
      let sizeFindSecd = productDetails?.size.find(
        (pro) => pro.id === veriant.options[1]
      );
      console.log("Debug size", sizeFindSecd);

      if (sizeFind) {
        size = veriant.options[0];
      } else if (sizeFindSecd) {
        size = veriant.options[1];
      } else {
        size = veriant.options[2];
      }
    }
    return { colorCode: colorCode, size: size };
  };

  const processData = async () => {
    let cartData;
    let defaultvariant;
    cartData = localShopDetails?.product_details?.variants.find(
      (variant) => variant.inCart === true
    );
    if (cartData) {
      defaultvariant = cartData;
      setQuantity(cartData.cart_quantity);
      const defaultVeriantImg = localShopDetails.product_details?.images.filter(
        (item) => item.variant_ids.includes(defaultvariant.id)
      );
      setselectedVeriant(defaultvariant);
      let findValus = await findColorOrsize(
        defaultvariant,
        localShopDetails.product_details
      );
      setselectedColour(findValus.colorCode);
      setShowingImages(defaultVeriantImg);
      setselectedSize(findValus.size);
    }

    if (!defaultvariant) {
      defaultvariant = localShopDetails?.product_details?.variants.find(
        (variant) => variant.is_default === true
      );
    }
    console.log("Debug Default Variant", defaultvariant);

    if (defaultvariant) {
      if (defaultvariant.outOfStock) {
        setIsOutOfStock(true);
        setOutofstockText("Out Of Stock");
      } else {
        setIsOutOfStock(false);
        setMaxAvailableStock(null);
      }
      const defaultVeriantImg = localShopDetails.product_details?.images.filter(
        (item) => item.variant_ids.includes(defaultvariant.id)
      );
      if (!cartData) {
        setselectedVeriant(defaultvariant);
      }
      let findValus = await findColorOrsize(
        defaultvariant,
        localShopDetails.product_details
      );
      // setselectedColour(findValus.colorCode);
      setShowingImages(defaultVeriantImg);
      // setselectedSize(findValus.size);
      const defaultVedefaultImage = defaultVeriantImg.find(
        (item) => item.is_default === true
      );
      const imageUrl = defaultVedefaultImage?.src;
      if (imageUrl) {
        setInitialImageLoading(true);
        setImage(imageUrl);
        const imageIndex = localShopDetails.product_details.images.findIndex(
          (img) => img.src === imageUrl
        );
        setActiveIndex(imageIndex !== -1 ? imageIndex : 0);
      }
    }

    // Hide modal initial loading after processing data
    setTimeout(() => {
      setModalInitialLoading(false);
    }, 1000); // Adjust timing as needed
  };

  useEffect(() => setMounted(true), []);
  useEffect(() => {
    try {
      const raw = localStorage.getItem("cartCount");
      if (raw !== null) setCartCount(Number(raw) || 0);
    } catch {}
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    if (mounted) {
      try {
        const cached = localStorage.getItem("cartCount");
        const n = Number(cached);
        if (!Number.isNaN(n)) setCartCount(n);
      } catch {}
    }

    (async () => {
      try {
        const obj = {
          searchcondition: { user_id: getCookie("guest_id") },
          sort: { type: "asc", field: "priority" },
        };

        const res = await fetch(
          `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(obj),
            signal: controller.signal,
          }
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const rep = await res.json();

        if (rep?.status === "success" && Array.isArray(rep?.results?.res)) {
          const count = rep.results.res.reduce(
            (acc, item) => acc + (Number(item?.quantity) || 0),
            0
          );
          setCartCount(count);
          try {
            localStorage.setItem("cartCount", String(count));
          } catch {}
        }
      } catch (e) {
        console.error("Cart fetch failed:", e);
      } finally {
        try {
          localStorage.removeItem("cartUpdated");
        } catch {}
        document.cookie =
          "cartUpdated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }
    })();

    return () => controller.abort();
  }, [mounted, pathname]);

  useEffect(() => {
    async function fetchData() {
      let obj = {
        searchcondition: {
          user_id: getCookie("guest_id"),
        },
        sort: {
          type: "asc",
          field: "priority",
        },
      };

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...obj }),
      };

      let rep = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
        requestOptions
      );
      rep = await rep.json();
      console.log("rep============>", rep);

      if (rep.status === "success") {
        console.log("rep.results.res------->", rep.results.res);
        const count = rep.results.res?.reduce(
          (accumulator, currentValue) => accumulator + currentValue.quantity,
          0
        );
        console.log("count------->", count);
        setCartCount(parseInt(count));
      }
    }
    const handleCartUpdate = async () => {
      await fetchData();
      localStorage.removeItem("cartUpdated");
      document.cookie =
        "cartUpdated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    };

    window.addEventListener("cartUpdated", handleCartUpdate);

    window.addEventListener("storage", (e) => {
      if (e.key === "cartUpdated") {
        handleCartUpdate();
      }
    });

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
      window.removeEventListener("storage", handleCartUpdate);
    };
  }, []);

  // NEW EFFECT: Reset modal loading when modal opens
  useEffect(() => {
    if (openClothingDetailsModal) {
      setModalInitialLoading(true);
    }
  }, [openClothingDetailsModal]);

  useEffect(() => {
    processData();
  }, [localShopDetails.product_details]);

  useEffect(() => {
    if (localShopDetails.quantity == 0) {
      setQuantity(1);
    } else {
      setQuantity(localShopDetails.quantity);
    }
  }, [localShopDetails]);

  const processImages = (images) => {
    if (!images || images.length === 0) return [];

    const imageWithStatus = images.find(
      (img) =>
        img.imgfields &&
        img.imgfields.some(
          (field) => field.key === "img_status" && field.value === true
        )
    );

    const otherImages = images.filter(
      (img) =>
        !(
          img.imgfields &&
          img.imgfields.some(
            (field) => field.key === "img_status" && field.value === true
          )
        )
    );

    if (imageWithStatus) {
      return [imageWithStatus, ...otherImages];
    } else {
      return images;
    }
  };

  const images = localShopDetails.product_details.images;

  const showImage = (imgUrl, index) => {
    setImageLoading(true);
    setImage(imgUrl);
    setActiveIndex(index);
  };

  const handleImageLoad = () => {
    setImageLoading(false);
    setInitialImageLoading(false);
  };

  const productQuantity = async (type) => {
    let updatedQuantity;
    if (type == "add") {
      updatedQuantity = quantity + 1;
      // setQuantity(updatedQuantity);
    } else if (type == "remove") {
      if (quantity > 1) {
        updatedQuantity = quantity - 1;
      } else {
        return;
      }
    } else {
      return;
    }
    await addToCart(false, updatedQuantity);
  };

  const addToCart = async (isBuyNow, updatedQuantity) => {
    if (!selectedSize && (localShopDetails?.product_details?.size?.length ?? 0) > 0) {
      setSizeError(true);
      setSnackMsg(
        `Kindly select a valid size`
      );
      setSnackbarState(true);
      return;
    }
    if (!selectedColour && (localShopDetails?.product_details?.colors?.length ?? 0) > 0) {
      setColorError(true);
      setSnackMsg(
        `Kindly select a valid color`
      );
      setSnackbarState(true);
      return;
    }
    setLoaderOpen(true);

    let payload = {
      product_id: localShopDetails.product_details._id,
      quantity: updatedQuantity,
      user_id: getCookie("guest_id"),
      fromCartpage: true,
      verient_id: selectedVeriant.id,
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };

    try {
      let resp = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/add-update-cart`,
        requestOptions
      );
      resp = await resp.json();

      if (resp.status === "success") {
        setQuantity(updatedQuantity);
        setMaxAvailableStock(null);
        if (isBuyNow) {
          setOpenClothingDetailsModal(false);
          router.push("/checkout-page");
        }
      } else {
        setLoaderOpen(false);

        if (resp && resp.message && resp.hasOwnProperty("available_stock")) {
          const stockLimit = resp.available_stock;
          setSnackMsg(
            `Only ${stockLimit} of this item are available, and you already have them in your cart`
          );
          setSnackbarState(true);
          setQuantity(stockLimit);
        } else if (resp && resp.message) {
          setSnackMsg(resp.message);
          setSnackbarState(true);
        } else {
          setSnackMsg("Something went wrong!!");
          setSnackbarState(true);
        }
      }
      localStorage.setItem("cartUpdated", Date.now().toString());
      document.cookie = `cartUpdated=${Date.now()}; path=/`;
      window.dispatchEvent(new CustomEvent("cartUpdated"));
    } catch (error) {
      console.error("Add to cart error:", error);
      setSnackMsg("An unexpected error occurred.");
      setSnackbarState(true);
    } finally {
      setLoaderOpen(false);
    }
  };

  const closeSnack = () => {
    setSnackbarState(false);
  };

  const goToCart = () => {
    setOpenClothingDetailsModal(false);
    router.push("/shop/cart");
  };

  const clickOnColor = (val) => {
    setselectedColour(val);
    setMaxAvailableStock(null); // ++ ADDED
    setImageLoading(true);

    const result = localShopDetails.product_details?.variants.find((item) =>
      selectedSize
        ? item.options.includes(val) && item.options.includes(selectedSize)
        : item.options.includes(val)
    );
    console.log("Selected Product Variant After click color:", result);
    if (result && result.id) {
      if (result.outOfStock) {
        setIsOutOfStock(true);
        setOutofstockText("Out Of Stock");
        setMaxAvailableStock(0);
        setImageLoading(false);
      } else {
        setIsOutOfStock(false);
        setMaxAvailableStock(null);
        const defaultVeriantImg =
          localShopDetails.product_details?.images.filter((item) =>
            item.variant_ids.includes(result.id)
          );
        setselectedVeriant(result);
        setShowingImages(defaultVeriantImg);
        const defaultVedefaultImage = defaultVeriantImg.find(
          (item) => item.is_default === true
        );
        const imageUrl = defaultVedefaultImage?.src;
        if (imageUrl) setImage(imageUrl);
      }
    } else {
      setIsOutOfStock(true);
      setOutofstockText("Out Of Stock");
      setImageLoading(false);
    }
  };

  const clickSize = (val) => {
    setselectedSize(val);
    setMaxAvailableStock(null);

    const result = localShopDetails.product_details?.variants.find((item) =>
      selectedColour
        ? item.options.includes(val) && item.options.includes(selectedColour)
        : item.options.includes(val)
    );

    console.log("Selected Product Variant After click size:", result);

    if (result && result.id) {
      if (result.outOfStock) {
        setIsOutOfStock(true);
        setOutofstockText("Out Of Stock");
        setImageLoading(false);
      } else {
        setIsOutOfStock(false);
        setMaxAvailableStock(null);
        const defaultVeriantImg =
          localShopDetails.product_details?.images.filter((item) =>
            item.variant_ids.includes(result.id)
          );
        setselectedVeriant(result);
        setShowingImages(defaultVeriantImg);
        const defaultVedefaultImage = defaultVeriantImg.find(
          (item) => item.is_default === true
        );
        const imageUrl = defaultVedefaultImage?.src;
        if (imageUrl) setImage(imageUrl);
      }
    } else {
      setIsOutOfStock(true);
      setOutofstockText("Out Of Stock");
    }
  };

  return (
    <>
      <Modal
        open={openClothingDetailsModal}
        onClose={handleNewClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main banner_modal_main_new banner_modal_main_new1 shop_details_modal clothing_modal_full"
      >
        <div className="main_wrpr_finddivine clothing_modal_sub">
          <FloatingCartButton count={cartCount} hidden={hideCartOnThisRoute} />
          {/* Navigation Arrows */}
          <button
            className="nav_arrow nav_arrow_prev"
            onClick={() => handleNavigation("prev")}
            disabled={navigationLoading}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1001,
              background: "rgba(0, 0, 0, 0.5)",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: navigationLoading ? "not-allowed" : "pointer",
              opacity: navigationLoading ? 0.5 : 1,
              transition: "all 0.3s ease",
            }}
          >
            <ArrowBackIosIcon style={{ color: "white", fontSize: "24px" }} />
          </button>

          <button
            className="nav_arrow nav_arrow_next"
            onClick={() => handleNavigation("next")}
            disabled={navigationLoading}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 1001,
              background: "rgba(0, 0, 0, 0.5)",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: navigationLoading ? "not-allowed" : "pointer",
              opacity: navigationLoading ? 0.5 : 1,
              transition: "all 0.3s ease",
            }}
          >
            <ArrowForwardIosIcon style={{ color: "white", fontSize: "24px" }} />
          </button>

          <span className="close_btn" onClick={handleNewClose}>
            <CloseIcon />
          </span>
          <Box className="banner_modal_box_new banner_modal_box_neww">
            <Typography id="modal-modal-description" component="div">
              <div
                className={`sub_modal_banner_new ${styles.clothing_modal_main}`}
              >
                <div className="mdl_hdr">
                  <h2>{localShopDetails.product_details.name}</h2>
                </div>

                <div className={styles.tarrotcardposter_detailswrapper}>
                  <div className={styles.tarrotcardposter_detailswrapper_new}>
                    <div className={styles.left_sec_main_upper}>
                      <div className={styles.tarrotcardposter_imgsec}>
                        <div
                          className={styles.tarrotcardposter_imginnerwrap}
                          style={{ position: "relative" }}
                        >
                          <img
                            src={image}
                            alt=""
                            onLoad={handleImageLoad}
                            style={{
                              opacity:
                                imageLoading || initialImageLoading ? 0.5 : 1,
                              transition: "opacity 0.3s ease",
                            }}
                          />
                          {(imageLoading ||
                            initialImageLoading ||
                            modalInitialLoading) && (
                            <div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "black",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 10,
                              }}
                            >
                              <ShopLazyLoader
                                width="60%"
                                height="60%"
                                alt="shop image"
                                priority={true}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={styles.left_sec_main_lower}>
                      {showingImages && showingImages.length > 1 ? (
                        <div className={styles.thumbnail_carousel_container}>
                          {showingImages.length > 4 && (
                            <button
                              className={styles.scroll_button}
                              onClick={() =>
                                document
                                  .getElementById("thumb_scroll_box")
                                  .scrollBy({ left: -100, behavior: "smooth" })
                              }
                            >
                              &#8249;
                            </button>
                          )}

                          <div
                            id="thumb_scroll_box"
                            className={styles.thumbnail_scroll_box}
                          >
                            {showingImages.map((img, index) => {
                              const imgConcatedUrl = `${img.src}`;
                              return (
                                <div
                                  key={index}
                                  className={`${styles.image_box} ${
                                    index === activeIndex ? styles.active : ""
                                  }`}
                                  onClick={() =>
                                    showImage(imgConcatedUrl, index)
                                  }
                                >
                                  <img src={imgConcatedUrl} alt="" />
                                </div>
                              );
                            })}
                          </div>

                          {showingImages.length > 4 && (
                            <button
                              className={styles.scroll_button}
                              onClick={() =>
                                document
                                  .getElementById("thumb_scroll_box")
                                  .scrollBy({ left: 100, behavior: "smooth" })
                              }
                            >
                              &#8250;
                            </button>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className={styles.tarrotcardposter_detailssec}>
                    <div className={styles.content_part}>
                      <h2>{localShopDetails.product_details.name}</h2>
                      <div className={styles.price_section}>
                        <h4 className={styles.product_price}>
                          ${selectedVeriant?.price}
                        </h4>
                      </div>

                      <div className={styles.product_color_options}>
                        <p className={styles.option_label}>
                          Color:{" "}
                          <span className={styles.selected_option}>
                            {
                              localShopDetails.product_details.colors.find(
                                (c) => c.id === selectedColour
                              )?.title
                            }
                          </span>
                        </p>
                        <div className={styles.color_sec}>
                          {(showAllColors
                            ? localShopDetails.product_details.colors
                            : localShopDetails.product_details.colors.slice(
                                0,
                                6
                              )
                          ).map((colors, index) => {
                            return Array.isArray(colors?.colors) &&
                              colors.colors[0] ? (
                              <div
                                key={index}
                                className={`${styles.color_box} ${
                                  selectedColour == colors.id
                                    ? `${styles.acticeColor} active_style`
                                    : ""
                                }`}
                                style={{ backgroundColor: colors.colors[0] }}
                                onClick={() => clickOnColor(colors.id)}
                                title={colors.title}
                              ></div>
                            ) : null;
                          })}

                          {!showAllColors &&
                            localShopDetails.product_details.colors.length >
                              6 && (
                              <div
                                className={styles.color_box_more}
                                onClick={() => setShowAllColors(true)}
                              >
                                +
                                {localShopDetails.product_details.colors
                                  .length - 6}
                              </div>
                            )}
                        </div>
                        {colorError && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "13px",
                              margin: 0,
                            }}
                          >
                            *Color selection required
                          </p>
                        )}
                      </div>

                      <div className={styles.product_color_options}>
                        <p className={styles.option_label}>
                          Size:
                          <span className={styles.selected_option}>
                            {localShopDetails.product_details.size.find(
                              (c) => c.id === selectedSize
                            )?.title || ""}
                          </span>
                        </p>
                        <div className={styles.size_sec}>
                          {localShopDetails.product_details.size.map(
                            (size, index) => {
                              return (
                                <div
                                  key={index}
                                  className={`${styles.sizeShowWrapper} ${
                                    selectedSize == size.id
                                      ? `${styles.acticeSize} active_style`
                                      : ""
                                  }`}
                                  onClick={() => clickSize(size.id)}
                                >
                                  {size.title}
                                </div>
                              );
                            }
                          )}
                        </div>
                        {sizeError && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "13px",
                              margin: 0,
                            }}
                          >
                            *Size selection required
                          </p>
                        )}
                      </div>
                      <div className={styles.tarrotcardposter_cartbtn}>
                        {!isOutOfStock ? (
                          <>
                            <div className={styles.cart_itemcontent_lowerleft}>
                              <div className={styles.quantity_controls}>
                                <button
                                  className={styles.quantity_btn}
                                  onClick={() => {
                                    productQuantity("remove");
                                  }}
                                  disabled={quantity <= 1}
                                >
                                  <RemoveIcon />
                                </button>
                                <span className={styles.quantity_display}>
                                  {quantity}
                                </span>
                                <button
                                  className={styles.quantity_btn}
                                  onClick={() => {
                                    productQuantity("add");
                                  }}
                                >
                                  <AddIcon />
                                </button>
                              </div>
                            </div>
                            <div className={styles.shoppagebuttons}>
                              <button
                                className={styles.add_to_cart_btn}
                                onClick={() => addToCart(false, quantity)}
                              >
                                Add to Cart
                              </button>
                              <button
                                className={styles.buy_now_btn}
                                onClick={() => addToCart(true, quantity)}
                              >
                                Buy Now
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className={styles.out_of_stock}>
                            <h5 className={styles.cart_itemcontent_lowerright}>
                              {outofstockText}
                            </h5>
                            <button onClick={() => goToCart()}>
                              Go To Cart
                            </button>
                          </div>
                        )}

                        <div
                          style={{
                            color: "#f0f0f0",
                            marginTop: "10px",
                            fontSize: "14px",
                          }}
                        >
                          Made Just For You: This item is created on-demand.
                          Please check the size chart carefully, as we cannot
                          accept returns for incorrect sizes. See our full{" "}
                          <Link
                            href="/returns-policy"
                            // type="button"
                            // className={`${
                            //   pathname && pathname == "/" ? "active2" : ""
                            // }`}
                            onClick={() => router.push("/")}
                          >
                            Returns Policy
                          </Link>{" "}
                          for details.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.product_details_section}>
                  <div
                    className={styles.details_header}
                    onClick={() => setProductDetailsOpen(!productDetailsOpen)}
                  >
                    <h2>Product Details</h2>
                    <span className={styles.dropdown_arrow}>
                      {productDetailsOpen ? "▲" : "▼"}
                    </span>
                  </div>
                  {productDetailsOpen && (
                    <div className={styles.details_content}>
                      <div className={styles.product_features}>
                        {localShopDetails.product_details.description_part_1
                          ?.match && (
                          <div
                            className={styles.feature_item}
                            dangerouslySetInnerHTML={{
                              __html:
                                localShopDetails.product_details
                                  .description_part_1.match,
                            }}
                          />
                        )}
                        {localShopDetails.product_details.description_part_2
                          ?.match && (
                          <div
                            className={styles.feature_item}
                            dangerouslySetInnerHTML={{
                              __html:
                                localShopDetails.product_details
                                  .description_part_2.match,
                            }}
                          />
                        )}
                        {!localShopDetails.product_details.description_part_2
                          ?.match &&
                          !localShopDetails.product_details.description_part_1
                            ?.match &&
                          localShopDetails.product_details.description && (
                            <div
                              className={styles.feature_item}
                              dangerouslySetInnerHTML={{
                                __html:
                                  localShopDetails.product_details.description,
                              }}
                            />
                          )}
                      </div>

                      {localShopDetails.product_details.description_table && (
                        <div className={styles.size_chart_section}>
                          <h4>Size Chart</h4>
                          <div
                            className={styles.size_chart_content}
                            dangerouslySetInnerHTML={{
                              __html:
                                localShopDetails.product_details
                                  .description_table,
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className={styles.shipping_section}>
                  <div
                    className={styles.details_header}
                    onClick={() => setShippingReturnsOpen(!shippingReturnsOpen)}
                  >
                    <h4>Shipping & Returns</h4>
                    <span className={styles.dropdown_arrow}>
                      {shippingReturnsOpen ? "▲" : "▼"}
                    </span>
                  </div>
                  {shippingReturnsOpen && (
                    <div className={styles.details_content}>
                      <div className={styles.shipping_info}>
                        <p>Free shipping on orders over $50</p>
                        <p>30-day return policy</p>
                        <p>Easy returns and exchanges</p>
                        <p>Ships within 1-2 business days</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Typography>
          </Box>
        </div>
      </Modal>

      {copyRightOpen ? (
        <ComingSoonModal
          copyRightOpen={copyRightOpen}
          setCopyRightOpen={setCopyRightOpen}
        />
      ) : (
        ""
      )}

      <Modal
        open={loaderOpen || navigationLoading}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="linear_loader_modalbox">
          <LinearProgress />
        </Box>
      </Modal>

      <Snackbar
        open={snackbarState}
        autoHideDuration={3000}
        onClose={() => closeSnack()}
        className="snackbarClass"
        message={snackMsg}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        bodyStyle={{ backgroundColor: "teal", color: "coral" }}
      />
    </>
  );
};

export default ClothingModal;
